import i18n from '../i18n';

const isDivisible = packaging =>
  !!(
    packaging?.quantity_in_pack &&
    packaging?.quantity_in_unit &&
    packaging?.quantity_unit_in_pack &&
    packaging?.unit_name
  );

const isAnIndivisible = packaging =>
  packaging?.quantity_in_pack &&
  packaging?.quantity_in_unit &&
  packaging?.quantity_unit_in_pack === 1;

const getProductPositionData = (product, isInsuranceAgent) => {
  let { in_cart, pack_info } = product;
  let { quantity_in_pack, quantity_in_unit, quantity_unit_in_pack } = pack_info;
  let packageQty = in_cart / (quantity_in_pack / quantity_in_unit);
  let remainder = packageQty % 1;
  let numOfPackages = packageQty - remainder;
  let unitQty = Math.floor((quantity_unit_in_pack * remainder).toFixed(2));
  let pack = product?.pack_info?.unit_name ?? 'package';
  let packageType =
    quantity_in_pack / quantity_in_unit >= 1
      ? i18n.t(`labels.package`, {
          count: numOfPackages,
        })
      : i18n.t(`labels.${pack}`, {
          count: numOfPackages,
        });

  numOfPackages =
    isDivisible(pack_info) && isInsuranceAgent && quantity_unit_in_pack === 1
      ? `${packageQty} ${packageType}`
      : numOfPackages
      ? `${numOfPackages} ${packageType}`
      : '';
  unitQty =
    unitQty > 0
      ? `${unitQty} ${i18n.t(`labels.${pack}`, {
          count: unitQty,
        })}`
      : '';

  let plus = numOfPackages && unitQty ? '+' : '';

  return `${numOfPackages} ${plus} ${unitQty}`;
};

const getQuantity = item => {
  if (isDivisible(item.pack_info)) {
    return getQuantityOfDivisible(item);
  } else {
    return item.in_cart;
  }
};

const getQuantityOfDivisible = item => {
  if (item.in_cart > 0) {
    return parseInt(
      item.in_cart /
        (item.pack_info.quantity_in_pack / item.pack_info.quantity_in_unit)
    );
  }
};

const getTheNumberOfParts = item => {
  const remainder =
    (item.in_cart /
      (item.pack_info.quantity_in_pack / item.pack_info.quantity_in_unit)) %
    1;

  return Math.floor(
    (remainder * item.pack_info.quantity_unit_in_pack).toFixed(2)
  );
};

const calculateOnePackage = item => {
  return item.pack_info.quantity_in_pack / item.pack_info.quantity_in_unit;
};

const partCounter = 1;

const calculateOnePartOfThePackage = () => partCounter;

export {
  isDivisible,
  isAnIndivisible,
  getProductPositionData,
  getQuantity,
  getQuantityOfDivisible,
  getTheNumberOfParts,
  calculateOnePackage,
  calculateOnePartOfThePackage,
};
